import { MoneyConnectClientAPI } from "./axios-service-creator";

export const CommonAPI = {
  sendOTP: payload => MoneyConnectClientAPI.post("/payment/otp/send", payload),
}
